<div *ngIf="active" [ngClass]="{'preloader-active preloader-visible': active }" dir="ltr">
    <div class="preloader-container">
        <div class="preloader-overlay"></div>
        <div class="preloader-message-container" id="preloaderContainer" aria-live="assertive" aria-atomic="true">
            <div class="loader"></div>
        </div>        
    </div>    
</div>